import { FormType } from "../../../../types/forms";
import cx from "classnames";
import { ClientTaskType } from "../../../../types/dtos/tasks/advanced-tasks/ClientTaskType";
import TaskManagementConfigDto from "../../../../types/dtos/forms/TaskManagementConfigDto";
import { advancedTaskHelper } from "../../../../helpers";
import { t } from "i18next";

interface EnforcedCommentsValidityBannerProps {
  config: TaskManagementConfigDto;
  taskType: ClientTaskType;
  formType: FormType;
}

function EnforcedCommentsValidityBanner({
  config,
  taskType,
  formType,
}: EnforcedCommentsValidityBannerProps) {
  const taskDataSet = advancedTaskHelper.getTaskManagementQuestionTaskSet(config);

  const taskCount = taskDataSet.length;

  const taskName = advancedTaskHelper.ToLowerCase(
    taskType.pluralNameTranslationKeyIdentifier
  );
  const areEmployeeCommentsOptional = taskDataSet.some(
    (x) => x.enforcedComments.skipEmployeeRequiredComments
  );

  const validTaskCount =
    formType === "JOURNEY"
      ? // Journey - Only need to take into consideration owner count conditions
        taskDataSet.filter(
          (x) => x.enforcedComments.areOwnerCountConditionsSatisfied
        ).length
      : // Collab Doc - Need to check if the taskType has a review form
      taskType.reviewFormId != null
      ? // If it does then count newly created in this journey
        // OR count non-completed tasks that satisfy both owner and manager role conditions
        // OR completed tasks that have a review form response
        taskDataSet.filter(
          (x) =>
            x.isNewlyCreatedInThisJourney ||
            (x.status !== "COMPLETED" &&
              x.enforcedComments.areOwnerCountConditionsSatisfied &&
              x.enforcedComments.areManagerRoleCountConditionsSatisfied) ||
            (x.status === "COMPLETED" && x.hasReviewFormResponse)
        ).length
      : // If it doesn't then we count tasks that satisfy both owner and manager role conditions
        taskDataSet.filter(
          (x) =>
            x.enforcedComments.areOwnerCountConditionsSatisfied &&
            x.enforcedComments.areManagerRoleCountConditionsSatisfied
        ).length;

  const isInReviewModeWithEnforcedComments =
    config.enforceComments === true &&
    (config.questionMode == "TASK-REVIEW-AND-CREATION" ||
      config.questionMode == "TASK-REVIEW-ONLY");

  const bannerText = isInReviewModeWithEnforcedComments
    ? t("TaskType.EnforceComments.ReviewOnly.ValidityBannerText", {
        validTaskCount: validTaskCount,
        taskCount: taskCount,
        taskName: taskName,
      })
    : t("TaskType.EnforceComments.ValidityBannerText", {
        validTaskCount: validTaskCount,
        taskCount: taskCount,
        taskName: taskName,
      });

  return (
    <>
      {!(formType === "JOURNEY" && areEmployeeCommentsOptional) && (
        <p
          className={cx(
            "text-right mt-1",
            formType === "COLLAB-DOC" ? "text-gray-700" : "text-white"
          )}
        >
          {bannerText}
        </p>
      )}
    </>
  );
}

export default EnforcedCommentsValidityBanner;
